import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const ScrollWrapper = styled.ScrollView`
  flex: 1;
`;

export const Content = styled.View`
  padding: 24px;
    flex: 1;
`;

export const CardsList = styled.View`
  flex: 1;
  gap: ${RFValue(8)}px;
  justify-content: flex-start;
  box-shadow: rgba(149, 157, 165, 0.2) 4px 4px 4px;
`;

export const RequestCard = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(18)}px;
  padding: ${RFValue(16)}px;

  border: 1px solid ${({theme}) => theme.colors.border};
`;

export const RequestHeader = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${RFValue(12)}px;
`;

export const RequestTitle = styled.Text`
  flex: 1;
  font-size: ${RFValue(15)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const RequestBadge = styled.View`
  padding: ${RFValue(6)}px ${RFValue(10)}px;
  border-radius: ${RFValue(100)}px;
`;

export const RequestBadgeText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const RequestInfo = styled.View`
  margin-top: ${RFValue(10)}px;
`;

export const RequestRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${RFValue(10)}px;
`;

export const RequestLabel = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const RequestValue = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.semibold};
  text-align: right;
  padding-left: ${RFValue(50)}px;
  flex: 1;
`;

export const SummaryCard = styled.View`
  margin-top: ${RFValue(12)}px;
  padding: ${RFValue(14)}px;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  gap:${RFValue(10)}px;
  border: 1px solid ${({theme}) => theme.colors.border};
`;

export const SummaryRow = styled.View`
  flex-direction: row;
  justify-content: space-between;

`;

export const SummaryLabel = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const SummaryValue = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const DebitCard = styled.View`
  margin-top: ${RFValue(16)}px;
  padding: ${RFValue(14)}px;
  padding-top: ${RFValue(6)}px;  
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({theme}) => theme.colors.border};
`;

export const DebitRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  gap: ${RFValue(12)}px;
  margin-top: ${RFValue(10)}px;
`;

export const DebitColumn = styled.View`
  flex: 1;
`;

export const DebitLabel = styled.Text`
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const DebitValue = styled.Text`
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text_dark};
  text-transform: capitalize;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const DebitSeparator = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border};
  margin-top: ${RFValue(14)}px;
`;

export const EmptyState = styled.Text`
  margin-top: ${RFValue(24)}px;
  font-size: ${RFValue(14)}px;
  text-align: center;
  color: ${({theme}) => theme.colors.text};
`;

export const InfoBanner = styled.View`
  flex-direction: row;
  gap: ${RFValue(10)}px;
  background-color: ${({theme}) => theme.colors.gold_opacity};
  border: 1px solid ${({theme}) => theme.colors.gold};
  border-radius: ${RFValue(12)}px;
  padding: ${RFValue(12)}px;
  margin-bottom: ${RFValue(16)}px;
`;

export const InfoBannerText = styled.Text`
  flex: 1;
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.regular};
  line-height: ${RFValue(18)}px;
`;

export const Footer = styled.View`
  padding: 0 24px;
  margin-top: ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.background};
`;

interface SummaryListCardProps {
  accentColor: string;
}

export const SummaryListCard = styled.TouchableOpacity<SummaryListCardProps>`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${RFValue(12)}px;
  padding: ${RFValue(14)}px ${RFValue(14)}px;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(14)}px;
  border-left-width: 3px;
  border-left-color: ${({accentColor}) => accentColor};
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
  border-right-width: 1px;
  border-right-color: ${({theme}) => theme.colors.border};
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
`;


export const SummaryListDateWrapper = styled.View`
  flex: 1;
  flex-direction: column;
`;

export const SummaryListDateLabel = styled.Text`
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const SummaryListDateBold = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  margin-top: ${RFValue(2)}px;
`;

export const SummaryListRight = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const StatusBadge = styled.View`
  padding: ${RFValue(4)}px ${RFValue(8)}px;
  border-radius: ${RFValue(100)}px;
  margin-right: ${RFValue(8)}px;
`;

export const StatusBadgeText = styled.Text`
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
